<div class="wrapper">
  <button *ngIf="showCloseAll | async" class="close-all btn btn-sm btn-primary" (click)="onCloseAllClick()">
    {{ "Close all notifications" | translate }}
  </button>
  <div aria-live="polite" toastContainer>
    <!-- Toastr inserts its own DOM here -->
  </div>
</div>
